var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "the-section",
    { staticClass: "contact", attrs: { id: "contact" } },
    [
      _vm.mode !== "footer"
        ? [
            _c("line-footer", { staticClass: "decoration" }),
            _vm._v(" "),
            _c("contact-details", { attrs: { mode: _vm.mode } }),
          ]
        : _vm._e(),
      _vm._v(" "),
      _c("line-section"),
      _vm._v(" "),
      _c("div", { staticClass: "jobs", attrs: { id: "jobs" } }, [
        _c(
          "a",
          {
            staticClass: "title",
            attrs: { href: "#/jobs" },
            on: {
              click: function ($event) {
                return _vm.scrollTop()
              },
            },
          },
          [_vm._v("\n            Join "), _c("strong", [_vm._v("the tribe")])]
        ),
      ]),
      _vm._v(" "),
      _c("line-section"),
      _vm._v(" "),
      _c("contact-socials"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }